import React from 'react'

import MasksLoader from './_load/MasksLoader'
import MasksTable from './table/MasksTable'
import ControlBar from './ControlBar'
import MultiRowsActions from './table/MultiRowsActions'
import MultiSelectHandler from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'

const PageContent = () => {
  return (
    <>
      <ControlBar />
      <MultiSelectHandler>
        <MasksLoader uncontrolledChildren={<MultiRowsActions />}>
          <MasksTable />
        </MasksLoader>
      </MultiSelectHandler>
    </>
  )
}

export default PageContent
